module.exports = __webpack_public_path__ + "img/126ne.58125db2.svg";